// extracted by mini-css-extract-plugin
module.exports = {"container":"SECFilingView_container__1EkYl","content":"SECFilingView_content__2J43a","description":"SECFilingView_description__N37Vb"};